const reasons = [
  {
    icon: "ri-timer-flash-line",
    title: "最短即日対応",
    text: "急なご依頼・当日のお片付けにもスピーディーに対応。お電話一本で最短即日のご予約が可能です。",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "明朗会計・追加料金なし",
    text: "お見積り後の追加料金は一切いただきません。事前の写真見積りで安心の料金提示を行います。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "分別・搬出までワンストップ",
    text: "分別・搬出・積み込み・処分まで、スタッフがすべて対応。お客様の手を煩わせません。",
  },
  {
    icon: "ri-recycle-line",
    title: "適正処分・リサイクル",
    text: "京都市の条例・法令に則り、粗大ゴミ処分も適正に行います。リサイクル可能なものは積極的に再資源化します。",
  },
];

export default function Reasons() {
  return (
    <section id="reasons" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            REASONS
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            京都の不用品回収が
            <br className="sm:hidden" />
            <span className="text-primary-500">選ばれる理由</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {reasons.map((r) => (
            <div
              key={r.title}
              className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-7"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 mb-5">
                <i className={`${r.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3">
                {r.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}